'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.liveChatLink = exports.getResponderUserId = exports.getIsRestrictedToMaxConcurrentChats = exports.getHasVisitorEmail = exports.getInitialMessageText = exports.getMessageId = exports.getSessionId = exports.isResponderOnline = exports.getAskForEmail = exports.getResponders = exports.getResponder = exports.getAskForEmailMessage = exports.getIsOnlineMode = exports.getAwayMessage = exports.getWelcomeMessage = exports.getDomain = exports.getWidgetData = undefined;

var _WidgetDataModel = require('conversations-schema/models/WidgetDataModel');

var WidgetDataModel = _interopRequireWildcard(_WidgetDataModel);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _urls = require('conversations-lib/urls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getWidgetData = exports.getWidgetData = (0, _get2.default)('widgetData');

var getDomain = exports.getDomain = (0, _getIn2.default)(['widgetUi', 'domain']);

var getWelcomeMessage = exports.getWelcomeMessage = (0, _reselect.createSelector)(getWidgetData, (0, _get2.default)('message'));

var getAwayMessage = exports.getAwayMessage = (0, _reselect.createSelector)(getWidgetData, WidgetDataModel.getAwayMessage);

var getIsOnlineMode = exports.getIsOnlineMode = (0, _reselect.createSelector)(getWidgetData, WidgetDataModel.isOnlineMode);

var getAskForEmailMessage = exports.getAskForEmailMessage = (0, _reselect.createSelector)(getWelcomeMessage, function () {
  var welcomeMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return welcomeMessage.askForEmailMessage || _I18n2.default.text('default.askForEmailMessage');
});

var getResponder = exports.getResponder = (0, _reselect.createSelector)(getWidgetData, (0, _get2.default)('responder'));

var getResponders = exports.getResponders = (0, _reselect.createSelector)(getWidgetData, (0, _get2.default)('responders'));

var getAskForEmail = exports.getAskForEmail = (0, _reselect.createSelector)(getWelcomeMessage, (0, _get2.default)('askForEmail'));

var isResponderOnline = exports.isResponderOnline = (0, _reselect.createSelector)(getResponder, function (responder) {
  return Boolean((0, _get2.default)('online', responder));
});

var getSessionId = exports.getSessionId = (0, _reselect.createSelector)(getWidgetData, (0, _get2.default)('sessionId'));

var getMessageId = exports.getMessageId = (0, _reselect.createSelector)(getWelcomeMessage, (0, _get2.default)('id'));

var getInitialMessageText = exports.getInitialMessageText = (0, _reselect.createSelector)(getWelcomeMessage, (0, _get2.default)('initialMessage'));

var getHasVisitorEmail = exports.getHasVisitorEmail = (0, _reselect.createSelector)(getWidgetData, (0, _get2.default)('hasVisitorEmail'));

var getIsRestrictedToMaxConcurrentChats = exports.getIsRestrictedToMaxConcurrentChats = (0, _reselect.createSelector)(getWidgetData, (0, _get2.default)('agentsRestrictedToMaxConcurrentChats'));

var getResponderUserId = exports.getResponderUserId = (0, _reselect.createSelector)(getResponder, (0, _get2.default)('userId'));

var liveChatLink = exports.liveChatLink = (0, _reselect.createSelector)([getWelcomeMessage, getDomain], function () {
  var welcomeMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var domain = arguments[1];

  var isHubSpotPortal = welcomeMessage.portalId === 53;
  if (isHubSpotPortal) {
    return _urls.LINK_TO_LIVE_CHAT_INFO + '?hubs_campaign=hubspot-messages-virality&hubs_content=' + domain + '&hubs_cta=not-using-messages';
  }

  return _urls.LINK_TO_LIVE_CHAT_INFO + '?utm_campaign=hubspot-messages-virality&utm_source=' + domain + '&utm_medium=virality&utm_content=not-using-messages';
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/widgetDataSelectors.js
// module id = 17
// module chunks = 0 1